<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-chip v-on="on" small :color="color"></v-chip>
      </template>

      <table>
        <tr v-for="item in statusItems" :key="item.key">
          <td class="text-right font-weight-bold pr-1">{{ item.label }} :</td>
          <td class="text-left">{{ item.value ? "Completed" : "Pending" }}</td>
        </tr>
      </table>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },

  computed: {
    technical() {
      if (!this.booking || !this.booking.data) return {};

      try {
        const parsed = JSON.parse(this.booking.data);
        return parsed.technical || {};
      } catch (e) {
        // If data is not valid JSON, fail gracefully
        return {};
      }
    },
    flightDetails() {
      return !!this.technical.flight;
    },
    welcomePanel() {
      return !!this.technical.welcome;
    },
    clientProgram() {
      return !!this.technical.client;
    },
    appreciationSheet() {
      return !!this.technical.appreciation;
    },
    allHotelAreRoomingListSent() {
      const roomingListSent = Number(this.booking?.roomingListSent || 0);
      const totalHotelSuppliers = Number(this.booking?.totalHotelSuppliers || 0);

      if (!totalHotelSuppliers) return false;
      return roomingListSent === totalHotelSuppliers;
    },
    statusItems() {
      return [
        {
          key: "flight",
          label: "Flight Details",
          value: this.flightDetails,
        },
        {
          key: "welcome",
          label: "Welcome Sign sent",
          value: this.welcomePanel,
        },
        {
          key: "client",
          label: "Client's program sent",
          value: this.clientProgram,
        },
        {
          key: "appreciation",
          label: "Appreciation sheets",
          value: this.appreciationSheet,
        },
        {
          key: "rooming",
          label: "Rooming list sent",
          value: this.allHotelAreRoomingListSent,
        },
      ];
    },
    color() {
      const totalItems = this.statusItems.length;
      const completedCount = this.statusItems.filter((item) => item.value).length;

      if (completedCount === 0) return "red";
      if (completedCount === totalItems) return "green";
      return "orange";
    },
  },
};
</script>
